import React, { Component } from "react";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import AliasService from "../../../../services/transferencias/AliasService";
import TransferInterentidadService from "../../../../services/transferencias/TransferInterentidadService";
import authService from "../../../../services/login/auth.service";
import HabilitarAhorroProgramadoService from "../../../../services/autogestion/HabilitarAhorroProgramadoService";

//PopupAgreagrCuentaBasa
export default class PopupAgregarAlias extends Component {
  TIPO_DEBITO = "D";
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
    this.guardar = this.guardar.bind(this);
    this.validate = this.validate.bind(this);
    this.initData();
  }



  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
              window.location.reload();
            },
          },
        ],
      },
    });

    popRegistroAlias(){
      Popup.queue(this.notifiPopupRegistro("Atencion", "¿Está seguro de REGISTRAR este alias?" ));
    }

   


  initData() {
    this.listadoTipoAlias();
    this.listadoAlias();
    this.rucpersona = authService.getSocio().ruc;
    this.cipersona = authService.getSocio().numeroCedula;
    this.telefonopersona = authService.getSocio().celular;
    this.correopersona = authService.getSocio().correoElectronico;
    this.getCuentas(this.TIPO_DEBITO);
  }

  getInitialState = () => ({
    tipoNew: "",
    nroCuentaNew: "",
    aliasNew: "",
    tipoDocNew: "",
    documentoNew: "",
    listaAlias: [],
    listaCuenta: [],
    listaAliasSocio: [],
    consultarAlias: {},
    datosPersonales: [],
    rucpersona: "",
    telefonopersona: "",
    cipersona: "",
    correopersona: "",
    cuentasOrigen: [],
    // Estados para validación
    errors: {
      tipoNew: "",
      nroCuentaNew: "",
      aliasNew: ""
    },
    isFormValid: true
  });

   guardar() {
  
     this.BuscarAliasExterno().then((response) => {

      if(this.state.consultarAlias.data.codigoRetorno == "0"){
        if (this.state.consultarAlias.data.datos.numDocumento === this.state.aliasNew) {

        Popup.queue(this.notifiPopup('Atención', 'Alias ya existe.'));

        return null;

      }
      }
     
       if(this.state.listaAliasSocio.filter(obj => obj.alias === this.state.aliasNew).length > 0){

      Popup.queue(this.notifiPopup('Atención', 'Alias ya existe.'));
      
      return null;
      
    }
    
    if(this.state.listaAliasSocio.filter(item => `${item.nroCuenta}` ===  this.state.nroCuentaNew ).length > 0 ){
      Popup.queue(this.notifiPopup('Atención', 'La cuenta selecciona ya se encuentra asociada a un alias.'));
      return null; 
    }
    trackPromise(
    AliasService.registarAlias(
      
      (this.state.tipoNew === "MOBILE") ? "+595" + (this.state.aliasNew).slice(1): this.state.aliasNew,
      this.state.nroCuentaNew,
      "CAH",
      this.state.tipoNew
      
      
    )
      .then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        // if (jData.codigo === 0) {
        //   this.setState(this.getInitialState());
        //   this.modalCuenta.click();
        //   this.props.addCuentaCallback("OK");
        // } else {
        //   Popup.queue(this.notifiPopup("Error", jData.mensaje));
        //   this.props.addCuentaCallback("FAIL");
        // }
        if (jData.codigoRetorno == "0") {
          Popup.queue(this.notifiPopup("Info", "Alias registrado exitosamente"));
          
          
        }else{
          Popup.queue(this.notifiPopup("Error", "Ocurrio un error al momento de registrar el alias"));
        }
       
      })
    ).catch(function (error) {
        console.log(error);
      });

    });



  }


listadoAlias(){
    var respuestaAlias = [];
    trackPromise(
      AliasService.getListadoAlias().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        
        if (jData.codigoRetorno === "0") {
          var items = jData.datos;
          for (var i = 0; i < items.length; i++) {
            respuestaAlias.push({
              id: items[i].idPersona,
              alias: items[i].alias,
              tipoAlias: items[i].tipoAlias,
              nroCuenta: items[i].idAhorro,
              estado: items[i].estado,
              
            });
          }
        }

        this.setState({ listaAliasSocio: respuestaAlias });
        return this.state.listaAliasSocio;
       
      })
    ).catch(function (error) {
      console.log(error);
    });
  }


  async BuscarAliasExterno(){
    var consultaAliasExterno = [];
    
    const result = await trackPromise(TransferInterentidadService.getDatosAlias(this.state.aliasNew, this.state.tipoNew))
    
    this.setState({ consultarAlias: result });
    return result
    //  .then((response) => {
    //     console.log('jdata', response);
    //     var data = JSON.stringify(response.data);
    //     var jData = JSON.parse(data);
    //      console.log('data', jData);
    //     if (jData.codigoRetorno === "0") {
    //       var items = jData.datos;
         
         
    //     }
       
    //     this.setState({ consultarAlias: items });
    //    return items;
       
    //   })
    
    
  }



  listadoTipoAlias() {


    AliasService.getTipoAlias().then((response) => {
      var data = JSON.stringify(response.data);
      var jData = JSON.parse(data);

      if (jData.codigoRetorno === "0") {
        var itemsTipo = (jData.datos).filter(item => item !== "CRP" && item !== "CRC");


      }
      this.setState({ listaAlias: itemsTipo })

    })

  }



  // Funciones de validación nativas
  validateField = (fieldName, value) => {
    let error = "";
    
    switch (fieldName) {
      case "tipoNew":
        if (!value || value === "") {
          error = "Este campo es requerido";
        }
        break;
      case "nroCuentaNew":
        if (!value || value === "") {
          error = "Este campo es requerido";
        }
        break;
      case "aliasNew":
        if (!value || value === "") {
          error = "Este campo es requerido";
        }
        break;
      default:
        break;
    }
    
    return error;
  };

  validateForm = () => {
    const { tipoNew, nroCuentaNew, aliasNew } = this.state;
    const errors = {
      tipoNew: this.validateField("tipoNew", tipoNew),
      nroCuentaNew: this.validateField("nroCuentaNew", nroCuentaNew),
      aliasNew: this.validateField("aliasNew", aliasNew)
    };

    const isFormValid = !Object.values(errors).some(error => error !== "");
    
    this.setState({ errors, isFormValid });
    return isFormValid;
  };

  handleFieldBlur = (fieldName, value) => {
    const error = this.validateField(fieldName, value);
    this.setState({
      errors: {
        ...this.state.errors,
        [fieldName]: error
      }
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      this.guardar();
    }
  };

  validate = (e) => {
    // Función mantenida para compatibilidad pero ahora usa validación nativa
    this.handleSubmit(e);
  };


  handleChange(tipoAlias) {
    if (tipoAlias == 'CI') {
      return this.cipersona
    }
    if (tipoAlias == 'EMAIL') {
      return this.correopersona
    }
    if (tipoAlias == 'MOBILE') {
      return this.telefonopersona
    }
    if (tipoAlias == 'RUC') {
      return this.rucpersona
    }
  }
 

   getCuentas(tipo) {
      trackPromise(
        HabilitarAhorroProgramadoService.getCuentas(tipo).then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (tipo === this.TIPO_DEBITO) {
            this.setState({ cuentasOrigen: jsonData.resultadoAH });
          } 
        })
      );
    }


  // changeTipoEntidad = (tipoEntidad) => {

  //   let newState = this.state;

  //   console.log(tipoEntidad);

  // };

  render() {
    
    const listaTipoAlias = this.state.listaAlias.map((item) => (
      <option key={item} value={item}>
        {item}
      </option>
    ));

    listaTipoAlias.unshift(
      <option key="-1" value="" disabled>
        -- Seleccione--
      </option>
    );

    const listaCuenta = this.state.cuentasOrigen.map((item) => (
      <option key={item.ahorro} value={item.ahorro}>
          N° {item.ahorro} VISTA NORMAL
      </option>
    ));

    listaCuenta.unshift(
      <option key="-1" value="" disabled>
        -- Seleccione--
      </option>
    );

    // const listItems = this.props.items.map((item) => (
    //   <option key={item.id} value={item.id}>
    //     {item.nombre}
    //   </option>
    // ));

    // listItems.unshift(
    //   <option key="-1" value="" disabled>
    //     -- Seleccione--
    //   </option>
    // );

    // const listTiposDocumentos = this.props.tipos.map((elemento) => (
    //   <option key={elemento.id} value={elemento.id}>
    //     {elemento.descripcion}
    //   </option>
    // ));

    // listTiposDocumentos.unshift(
    //   <option key="-1" value="" disabled>
    //     -- Seleccione--
    //   </option>
    // );

    return (
      <form
        id="idFormAddCuenta"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div
          className="modal fade"
          id="modal-alias"
          data-backdrop="false"
        >
          <div className="modal-dialog  modal-dialog-centered  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Registrar Alias</h5>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Tipo de Alias</label>
                      <select
                        name="tipoNew"
                        value={this.state.tipoNew}
                        onChange={(selectedOption) => {
                          const newValue = selectedOption.target.value;
                          const newAlias = this.handleChange(newValue);
                          this.setState({
                            aliasNew: newAlias,
                            tipoNew: newValue,
                            errors: {
                              ...this.state.errors,
                              tipoNew: this.validateField("tipoNew", newValue),
                              aliasNew: this.validateField("aliasNew", newAlias)
                            }
                          });
                        }}
                        onBlur={(e) => this.handleFieldBlur("tipoNew", e.target.value)}
                        className={`form-control input-box ${this.state.errors.tipoNew ? 'is-invalid' : ''}`}
                        style={{ width: "100%" }}
                      >
                        {listaTipoAlias}
                      </select>
                      {this.state.errors.tipoNew && (
                        <span className="invalid-feedback">{this.state.errors.tipoNew}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Alias</label>
                      <input
                        readOnly 
                        name="aliasNew"
                        value={this.state.aliasNew}
                        type="text"
                        className={`input-box form-control ${this.state.errors.aliasNew ? 'is-invalid' : ''}`}
                      />
                      {this.state.errors.aliasNew && (
                        <span className="invalid-feedback">{this.state.errors.aliasNew}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Nro. de Cuenta</label>
                      <select
                        name="nroCuentaNew"
                        value={this.state.nroCuentaNew}
                        onChange={(selectedOption) => {
                          const newValue = selectedOption.target.value;
                          this.setState({
                            nroCuentaNew: newValue,
                            errors: {
                              ...this.state.errors,
                              nroCuentaNew: this.validateField("nroCuentaNew", newValue)
                            }
                          });
                        }}
                        onBlur={(e) => this.handleFieldBlur("nroCuentaNew", e.target.value)}
                        className={`form-control input-box ${this.state.errors.nroCuentaNew ? 'is-invalid' : ''}`}
                        style={{ width: "100%" }}
                      >
                        {listaCuenta}
                      </select>
                      {this.state.errors.nroCuentaNew && (
                        <span className="invalid-feedback">{this.state.errors.nroCuentaNew}</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-cu-quintary"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.setState(this.getInitialState());
                  }}
                >
                  Cerrar
                </button>
                <button
                  className="btn btn-cu-primary"
                  onClick={(e) => {
                    this.handleSubmit(e);
                  }}
                >
                  Guardar
                </button>
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
          <a
            data-controls-modal="modal-cuenta"
            ref={(a) => (this.modalCuenta = a)}
            data-backdrop="false"
            href="#"
            hidden
            id="showModalCuenta"
            data-toggle="modal"
            data-target={"#modal-cuenta"}
          ></a>
        </div>
      </form>
    );
  }
}
